exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.save-status_save-now_1Blzi {\r\n    cursor: pointer;\r\n    padding: 0 0.5rem;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.save-status_save-now_1Blzi:hover {\r\n    background-color: var(--ui-black-transparent);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"save-now": "save-status_save-now_1Blzi",
	"saveNow": "save-status_save-now_1Blzi"
};